/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitHostingProviderResult } from './MonitHostingProviderResult';
import {
    MonitHostingProviderResultFromJSON,
    MonitHostingProviderResultFromJSONTyped,
    MonitHostingProviderResultToJSON,
} from './MonitHostingProviderResult';

/**
 * 
 * @export
 * @interface MonitHostingAggResult
 */
export interface MonitHostingAggResult {
    /**
     * 
     * @type {number}
     * @memberof MonitHostingAggResult
     */
    total?: number;
    /**
     * 
     * @type {Array<MonitHostingProviderResult>}
     * @memberof MonitHostingAggResult
     */
    providers?: Array<MonitHostingProviderResult>;
}

/**
 * Check if a given object implements the MonitHostingAggResult interface.
 */
export function instanceOfMonitHostingAggResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitHostingAggResultFromJSON(json: any): MonitHostingAggResult {
    return MonitHostingAggResultFromJSONTyped(json, false);
}

export function MonitHostingAggResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitHostingAggResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'providers': !exists(json, 'providers') ? undefined : ((json['providers'] as Array<any>).map(MonitHostingProviderResultFromJSON)),
    };
}

export function MonitHostingAggResultToJSON(value?: MonitHostingAggResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'providers': value.providers === undefined ? undefined : ((value.providers as Array<any>).map(MonitHostingProviderResultToJSON)),
    };
}

